import { CHECKLIST_ITEM_IDS, type ChecklistItemId } from "../lib/checklistIds";
import type { UiKey } from "../i18n/ui";

type Props = {
  t: (key: UiKey) => string;
  value: Record<ChecklistItemId, boolean>;
  onChange: (id: ChecklistItemId, checked: boolean) => void;
};

export function ChecklistCard({ t, value, onChange }: Props) {
  return (
    <div>
      <h2>{t("checklist.title")}</h2>
      <ul className="list">
        {CHECKLIST_ITEM_IDS.map((id) => (
          <li key={id}>
            <label className="row">
              <input
                type="checkbox"
                checked={value[id]}
                onChange={(e) => onChange(id, e.target.checked)}
              />
              <span>{t(`checklist.${id}` as UiKey)}</span>
            </label>
          </li>
        ))}
      </ul>
      <style>{`
        h2 {
          font-size: 1rem;
          margin: 0 0 0.75rem;
        }
        .list {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .list li {
          padding: 0.35rem 0;
          border-bottom: 1px solid var(--border);
        }
        .list li:last-child {
          border-bottom: none;
        }
        .row {
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
          cursor: pointer;
          font-size: 0.88rem;
          color: var(--text);
        }
        .row input {
          margin-top: 0.2rem;
          accent-color: var(--accent);
        }
      `}</style>
    </div>
  );
}
